import type { Form } from '../../interfaces/form.interface';
import { ReactiveDependencyGraph } from '../dependencies/reactive-dependency-graph';

export class ReactiveDropdownDependencyGraphStore<T> {

  private graph: ReactiveDependencyGraph<T> | null = null;
  private signature = '';

  public constructor(private readonly getForm: () => Form<T> | null) {}

  public getGraph(): ReactiveDependencyGraph<T> {
    const form = this.getForm();
    const nextSignature = this.createSignature(form);

    if (!this.graph || this.signature !== nextSignature) {
      this.graph = new ReactiveDependencyGraph<T>(form);
      this.signature = nextSignature;
    }

    return this.graph;
  }

  public invalidate(): void {
    this.graph = null;
    this.signature = '';
  }

  private createSignature(form: Form<T> | null): string {
    if (!form) {
      return 'empty';
    }

    const formDependencies = JSON.stringify(form.dependencies ?? []);
    const fieldDependencies = (form.sections ?? [])
      .flatMap((section) => section.fields ?? [])
      .map((field) => ({
        name: field.name ?? '',
        dataSourceDependsOn: field.dataSource?.dependsOn ?? [],
        dependencies: field.dependencies ?? [],
      }));

    return JSON.stringify({ formDependencies, fieldDependencies });
  }
}
